import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { GetShareProductsDto } from './api.dto';
import { ReturnTypeGetListWishlist } from '../types/wishlistShema';

export const fetchGetShareProducts = createAsyncThunk<ReturnTypeGetListWishlist, GetShareProductsDto>(
  'wishlist/fetchGetShareProducts',
  async ({ regionId, hash }) => {
    return await MyAxios.get(`/api/wishlist/get-products-by-hash?regionId=${regionId}&hash=${hash}`).then(handleResponse).catch(handleError);
  },
);
